import { resolveFanficWorkListBase } from '@/lib/resolve-fanfic-work-list-base';
import type { ListingStructuredWork } from '@/features/seo-listing/utils/build-listing-structured-data';
import type { FanficDisplay } from '../transform-fanfic-data.util';

type GetShownWorksInput = {
  readonly fanfics: readonly Pick<FanficDisplay, 'id' | 'title' | 'type'>[];
  readonly isLoadingResults: boolean;
  readonly hasError: boolean;
  readonly pathname: string;
  readonly isOriginals: boolean;
};

/**
 * Works currently visible in the catalog, in list order.
 * Empty while the listing is loading, failed, or has no cards.
 */
export function getShownWorks(input: GetShownWorksInput): ListingStructuredWork[] {
  if (input.isLoadingResults || input.hasError || input.fanfics.length === 0) {
    return [];
  }
  const detailPathPrefix = input.isOriginals ? '/originals' : undefined;
  return input.fanfics.map((fanfic) => ({
    title: fanfic.title,
    href: `${resolveFanficWorkListBase(input.pathname, detailPathPrefix, fanfic.type)}/${fanfic.id}`,
  }));
}
